import faker from 'faker';

const StatusBM = [
  {
    name: 'Aguardando Fornecedor',
    data: [{ x: 0, y: faker.random.number({ min: 10, max: 500 }) }],
  },
  {
    name: 'Aguardando Análise Quantitativa',
    data: [{ x: 1, y: faker.random.number({ min: 10, max: 500 }) }],
  },
  {
    name: 'Aguardando Correção do Fornecedor',
    data: [{ x: 2, y: faker.random.number({ min: 10, max: 500 }) }],
  },
  {
    name: 'Aguardando Lançamento de SLA',
    data: [{ x: 3, y: faker.random.number({ min: 10, max: 500 }) }],
  },
  {
    name: 'Aguardando Validação',
    data: [{ x: 4, y: faker.random.number({ min: 10, max: 500 }) }],
  },
  {
    name: 'Aguardando Aceite do Fornecedor',
    data: [{ x: 5, y: faker.random.number({ min: 10, max: 500 }) }],
  },
  {
    name: 'Concluído',
    visible: false,
    data: [{ x: 6, y: faker.random.number({ min: 10, max: 500 }) }],
  },
  {
    name: 'Cancelado',
    visible: false,
    data: [{ x: 7, y: faker.random.number({ min: 10, max: 500 }) }],
  },
];

export default StatusBM;